__turbopack_context__.v({
  "mobile-icon-carousel": "mobile-icon-carousel-component-module-scss-module__7qQQ9q__mobile-icon-carousel",
  "mobile-icon-carousel--editor-mode": "mobile-icon-carousel-component-module-scss-module__7qQQ9q__mobile-icon-carousel--editor-mode",
});
